import React from 'react';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import { Box } from '@mui/material';
import Placeholder from 'assets/images/placeholder.webp';
import { YouTubeLiteEmbed } from '@utriper/core-ui';

const Image = ({ src = Placeholder, alt = 'placeholder' }) => {
    return (
        <Box sx={{ width: '100%', height: 'fit-content' }}>
            <Box
                component="img"
                src={src}
                alt={alt}
                sx={{
                    aspectRatio: '16 / 9',
                    objectFit: 'cover',
                    objectPosition: 'center',
                    width: '100%',
                    height: 'auto',
                }}
            />
        </Box>
    );
};

const MediaCarousel = ({ experienceMedia = [] }) => {
    if (!Array.isArray(experienceMedia) || experienceMedia?.length <= 0) {
        return <Image />;
    }

    return (
        <Carousel showThumbs={false} showStatus={false}>
            {experienceMedia.map(({ src, type, originalName = '' }, index) => (type === 1 ? <Image src={`${process.env.REACT_APP_CDN_URL}${src}`} alt={originalName} /> : type === 3 ? <YouTubeLiteEmbed videoId={src} title=" " /> : <Image />))}
        </Carousel>
    );
};

export default MediaCarousel;
